module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/menu_icon_section-c2f45.png";